import { Grid, Typography } from '@mui/material';
import { EmployeeResponse } from 'api/services/workforce/workforce-service.types';

type Props = {
  data: EmployeeResponse;
};

export const EmployeeInformationTab = ({ data }: Props) => {
  return (
    <Grid item container xs={12} spacing={4} marginLeft={0}>
      <Grid item xs={4}>
        <Typography variant="subtitle1">Voornaam</Typography>
        <Typography variant="body1">{data.firstName}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">Tussenvoegsel</Typography>
        <Typography variant="body1">{data.infix ?? '-'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">Achternaam</Typography>
        <Typography variant="body1">{data.lastName}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">Email</Typography>
        <Typography variant="body1">{data.email}</Typography>
      </Grid>
    </Grid>
  );
};
